import {
  galerie2iv2itMock,
  galerie4itivMock,
  galerieit2iviMock,
  titreDescriptionMenuVisuelMock,
} from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [titreDescriptionMenuVisuelMock, galerieit2iviMock, galerie4itivMock, galerie2iv2itMock];

export const tendancesMock: SlugPage = {
  ...pageBase({
    title: 'Tendances',
    type: 'tendances',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: true,
  }),
  blocks,
};
